exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.example[data-v-44528109] {\n  padding: 0 10px;\n}\n", ""]);

// exports
